import React from 'react';
import { SearchIcon } from '../../icons';
import { TextField } from './TextField';
import clsx from 'clsx';

export const PageTitle = ({
  title,
  subTitle,
  endComponent,
  className,
  wrapperClassName,
  searchClassName,
  displaySearch = true,
  titleComponent,
  searchInput,
  placeholder = 'Αναζήτηση',
  handleSearch = () => {},
}) => {
  return (
    <div
      className={clsx('flex max-lg:flex-col xl:gap-6 gap-4', wrapperClassName)}
    >
      <div
        className={clsx(
          'flex flex-col gap-x-3 gap-y-4 justify-center',
          className
        )}
      >
        {titleComponent && titleComponent}
        {title && title}
        {subTitle && <div className="text-body" style={{ whiteSpace: 'pre-wrap' }}>{subTitle}</div>}
      </div>

      {displaySearch && (
        <TextField
          wrapperClass={clsx('flex-auto', searchClassName)}
          className={
            'h-full rounded-full text-body border-none items-center px-5 py-2 lg:py-4 '
          }
          placeholder={placeholder}
          value={searchInput}
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
          icon={<SearchIcon />}
        />
      )}
      {endComponent}
    </div>
  );
};

export default PageTitle;
